module.exports = __webpack_public_path__ + "static/media/dirk.10708188.jpg";